import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/shareIcons/pencil_fill.svg'


const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = {
  key: 0,
  class: "pad-s"
}
const _hoisted_4 = {
  class: "row gap-04",
  style: {"margin-left":"auto","margin-top":"-0.1rem"}
}
const _hoisted_5 = { class: "item-l" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mleft-05" }
const _hoisted_8 = {
  key: 0,
  class: "row mtop-08 w-full"
}
const _hoisted_9 = { class: "col gap-10 mleft-02" }

import editMedicName from './editMedicName.vue';
import editPharmacyPrescription from './editPharmacyPrescription.vue';
import { ref, computed, watch } from 'vue';
import gen from "@/functions/general";
import { normalizeString } from "@/functions/medicReference";
import { getSubstTerm, getSubstFamilyTerm } from '@/functions/expression';
import { useReferenceStore } from '@/stores/reference';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import patientapi from "@/api/patientapi";
import { medicSearchEngines, getSearchEnginePath }  from '@/functions/externalReference';
import { useI18n } from 'vue-i18n';
import { ApiError, ConceptGroupResponse, FolderPatientApi } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { getSingleElement } from '@/utils/array-utils';
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'editMedicDoseUpper',
  props: {
  isDashbTitle: {
    type: Boolean,
    default: false
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();
const referenceStore = useReferenceStore();
const toast = useToast();
const route = useRoute();
const emits = __emit;

const folderPatientApi = new FolderPatientApi(medServerApiConfig);



const dropd = ref("")
const routeRef = ref(null)

const commercialName = ref<string>("");
const administrationRouteText = ref<string>("");
const sapConcept = computed(() => currentEntryStore.sapConcept);

const definingSapExpression = computed(() => {
  return sapConcept.value?.definingSapExpression ?? currentEntryStore.poppedSapExpr
})

const substanceTerms = computed(() => {
  const sapExpr = definingSapExpression.value
  const ret = getSubstTerm(sapExpr) || currentEntryStore.poppedSapExpr?.substanceTerm || ''
  return gen.capitalize(ret)
})

const substanceFamilyTerm = computed(() => {
  const sapExpr = definingSapExpression.value
  let ret = getSubstFamilyTerm(sapExpr)
  ret = gen.capitalize(ret)
  return ret  
//sctContentFamily1
})

const localPrescriptionType = ref(null)
const localCustomDays = ref(null)

watch(sapConcept, (val) => {
  localPrescriptionType.value = val?.pharmacyPrescriptionType ?? 'DefaultDuration'
  localCustomDays.value = val?.customPrescriptionDays ?? null
}, { immediate: true })

const prescriptionLabel = computed(() => {
  const type = localPrescriptionType.value || 'DefaultDuration'
  if (type === 'CustomDuration') {
    const days = localCustomDays.value
    return days
      ? t('patient.pharmacy.label.CustomDuration', { days })
      : t('patient.pharmacy.label.DefaultDuration')
  }
  return t(`patient.pharmacy.label.${type}`)
})

function closeFct() {
  dropd.value = ""
  emits('close');
}

async function handleSavePrescriptionDuration(payload) {
  if (!sapConcept.value) return;
  localPrescriptionType.value = payload.prescriptionDuration
  localCustomDays.value = payload.customDurationDays ?? null
  currentEntryStore.patchSapConcept({
    pharmacyPrescriptionType: payload.prescriptionDuration,
    customPrescriptionDays: payload.customDurationDays ?? null,
  })
  await patientapi.updateSapPharmacyPrescription(payload.conceptGroupId, payload.prescriptionDuration, payload.customDurationDays)
}

function engineSearchFCT(el) {
  const term = definingSapExpression.value.matchedText
  const path = getSearchEnginePath(el, term)
  window.open(path)
    // if (el.name === 'cbip') {
  //   const terms = substances.value.replace(" + ", "+")
  //   path = getCbipSearchEnginePath(el, terms)
}

const normalizedSearchString = computed(() => {
  return normalizeString(administrationRouteText.value)
})


const routeList = ref([])

function matchFct() {
  const searchString = normalizedSearchString.value
  const searchParts = searchString.split(" ")
  const firstMatch = routeList.value.find(route => 
    searchParts.every(part => route.searchTerm.includes(part))
  )
  if (firstMatch) {
    const { administrationRouteId: routeId } = firstMatch
    scrollToItem(routeId)
  }
}

function scrollToItem(routeId) {
  const elementId = 'route_' + routeId
  const targetElement = document.getElementById(elementId)
  if (!targetElement) {console.log("Didn't find element with id: " + elementId); return;}
  targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

function setRouteSuggestion(newRoute: { term: string }) {
  currentEntryStore.setPoppedSapNewRouteTerm(newRoute.term)
  routeRef.value.hideDropdown()
}

function initialize() {
  let adminRoutes = gen.deepCopy(referenceStore.administrationRouteReference)
  adminRoutes.forEach(route => route.showTerm = route.term
    .toLowerCase()
    .replace("route", "")
    .replace("voie ", "")
    .replace("par une ", "")
    .replace("par la ", "")
    .replace("par ", "")
    .trim())
  adminRoutes.forEach(route => route.showTerm = route.showTerm.length <= 2 ? route.showTerm.toUpperCase() : route.showTerm)
  adminRoutes.forEach(route => route.searchTerm = normalizeString(route.showTerm))
  adminRoutes = adminRoutes.sort((a, b) => a.showTerm.localeCompare(b.showTerm))

  let sctidListToMove = new Set(["26643006", "47625008", "78421000", "34206005"])   //= PO, IV, IM, SC
  let itemsToMove = []
  let remainingItems = []
  for (let route of adminRoutes) {
    if (sctidListToMove.has(route.administrationRouteId)) {
      itemsToMove.push(route)
    } else {
      remainingItems.push(route)
    }
  }
  routeList.value = [...itemsToMove, ...remainingItems]
}

watch(
  () => currentEntryStore.poppedSapExpr,
  async () => {
    initialize()
  },
  { immediate: true }
)

watch(
  () => currentEntryStore.poppedSapNewName,
  () => {
    commercialName.value = currentEntryStore.poppedSapNewName
  },
  { immediate: true }
)

watch(
  () => currentEntryStore.poppedSapNewRouteTerm,
  () => {
    administrationRouteText.value = currentEntryStore.poppedSapNewRouteTerm || ""
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_unref(currentEntryStore).poppedSapExpr)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.isDashbTitle ? '' : 'bg-card')
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (__props.isDashbTitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_text_item, {
                    txt: commercialName.value,
                    styles: "font-l",
                    class: "mleft-02 mtop-01 title-long-max-w"
                  }, null, 8, ["txt"])
                ]))
              : (_openBlock(), _createBlock(_component_dropdownBox, {
                  key: 1,
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                  openOn: "EditMedicName"
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(editMedicName, {
                      onClose: _cache[0] || (_cache[0] = ($event: any) => (closeFct()))
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, {
                      theme: "dropdown",
                      styles: "pad-s"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_text_item, {
                          txt: commercialName.value,
                          styles: "font-l",
                          class: "mleft-02 mtop-01 title-short-max-w"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(medicSearchEngines), (item, index) => {
                return (_openBlock(), _createBlock(_component_buttonGroup, {
                  key: index,
                  class: "rowcenter",
                  onClick: ($event: any) => (engineSearchFCT(item))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: item.logoImage,
                        alt: "Logo",
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, _hoisted_6)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_text_item, {
              txt: substanceTerms.value || '?',
              styles: "main-m",
              class: _normalizeClass(__props.isDashbTitle ? 'subst-long-max-w' : 'subst-short-max-w')
            }, null, 8, ["txt", "class"]),
            _createVNode(_component_text_item, {
              txt: substanceFamilyTerm.value || '?',
              styles: "main-m",
              class: _normalizeClass(__props.isDashbTitle ? 'subst-long-max-w' : 'subst-short-max-w')
            }, null, 8, ["txt", "class"])
          ]),
          (!__props.isDashbTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_inputComboBox2, {
                  ref_key: "routeRef",
                  ref: routeRef,
                  modelValue: administrationRouteText.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((administrationRouteText).value = $event)),
                  styles: "pad-m",
                  style: {"width":"12.8rem"},
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (matchFct()))
                }, {
                  dropd: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routeList.value, (route, index) => {
                          return (_openBlock(), _createBlock(_component_list_group, {
                            key: index,
                            id: 'route_' + route.administrationRouteId,
                            styles: "pad-s",
                            onClick: ($event: any) => (setRouteSuggestion(route))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_text_item, {
                                txt: route.showTerm
                              }, null, 8, ["txt"])
                            ]),
                            _: 2
                          }, 1032, ["id", "onClick"]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
                  openOn: "EditMedicDetails",
                  class: "mleft-auto",
                  style: {"margin-bottom":"-0.4rem"}
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(editPharmacyPrescription, {
                      sapConcept: sapConcept.value,
                      onSavePrescriptionDuration: handleSavePrescriptionDuration
                    }, null, 8, ["sapConcept"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_buttonGroup, { class: "align-center mleft-10" }, {
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                          src: _imports_0,
                          class: "img-grey"
                        }, null, -1)),
                        _createVNode(_component_text_item, {
                          txt: prescriptionLabel.value,
                          styles: "main-l",
                          class: "mleft-04 font-size-14"
                        }, null, 8, ["txt"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})